export const production = () => location.origin === 'https://dka.portal.dgtek.net'
